module.exports = __webpack_public_path__ + "img/perks_MLBShop.cb27f464.png";